import { Button } from "@/components/ui/button";
import {
  PAY_INVOICE_LABEL,
  type CustomerInvoice,
} from "./invoice-presentation";

/**
 * The hosted page is a third-party Stripe page the app holds no copy of, so
 * it opens in a new tab. The server only sets the URL while an on-terms
 * invoice is still payable.
 */
export function PayInvoiceLink({
  invoice,
  size,
}: {
  invoice: Pick<CustomerInvoice, "hostedInvoiceUrl">;
  size?: "sm";
}) {
  if (!invoice.hostedInvoiceUrl) {
    return null;
  }
  return (
    <Button asChild size={size}>
      <a
        href={invoice.hostedInvoiceUrl}
        target="_blank"
        rel="noopener noreferrer"
      >
        {PAY_INVOICE_LABEL}
      </a>
    </Button>
  );
}
